<div class="npdc-title">
  <h1>Kjell-G. Kjær’s Historic Register of Arctic Vessels</h1>
  <div class="npdc-title__actions">
    @if (
      authService.user() &&
      (permissions()?.mayUpdate || authService.canInvoke(authService.endpoints.createVesselEntry))
    ) {
      <button mat-flat-button class="npdc-toolbar-button" (click)="onAddVesselClick()">
        Add vessel
      </button>
    }
  </div>
</div>
<p>
  The Historic <a routerLink="/dataset/{{ vesselDataset }}"> Register</a>
  of Arctic Vessels provides ship data, historic facts and in many cases images of more than 1500
  vessels involved in fishing, sealing, and other activities in the Arctic in the past. The author
  studied history at UIT and has written several books and articles about ships, expeditions and
  sealing in the Arctic.
</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      placeholder="Search vessels"
      [ngModel]="search()"
      (keydown.enter)="onSearch($event)"
    />
  </div>
</div>

<app-list [resource]="vessels">
  @if (!vessels.error()) {
    <mat-nav-list>
      @for (vessel of vessels.value()?.items; track vessel.id; let isLast = $last) {
        <a mat-list-item routerLink="/vessel/{{ vessel.id }}">
          <mat-icon matListItemIcon>sailing</mat-icon>
          <span matListItemTitle>{{ vessel.content.name }}</span>
          <span matListItemLine>
            @if (vessel.content.type) {
              <b>Type: </b>{{ vessel.content.type }}
            } @else {
              <b>Type: </b>unknown
            }
          </span>
        </a>
      }
    </mat-nav-list>
  }
</app-list>

<mat-paginator
  showFirstLastButtons
  (page)="onPage($event)"
  [length]="count()"
  [pageIndex]="page()"
  [pageSize]="pageSize()"
  [pageSizeOptions]="[defaultPageSize, 30, 60, 120]"
/>
